import { gql } from '@apollo/client';
import { AssetWithDimensionsFragment } from '../../graphql/fragments/Asset';

export const ImageCardFragment = gql`
  fragment ImageCardFragment on ImageCard {
    ... on ImageCard {
      ctas {
        id
        text
        title
        url
      }
      header
      id
      image {
        ...AssetWithDimensionsFragment
      }
      subheader
      textAlignment
      imageCardTextColor: textColor
      title
    }
  }
  ${AssetWithDimensionsFragment}
`;

export default {};
